import { render } from "./Preferences.vue?vue&type=template&id=30bac132&scoped=true"
import script from "./Preferences.vue?vue&type=script&lang=js"
export * from "./Preferences.vue?vue&type=script&lang=js"

import "./Preferences.vue?vue&type=style&index=0&id=30bac132&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30bac132"]])

export default __exports__